import {
  FrontierClubLogo,
  MisfitsLogo,
  OutletsLogo,
  PrivateEventLogo,
} from "../content/contentExport";

const events = [
  {
    id: 12.5,
    title: "6202 Live at Rock the Mountain Concert Series",
    date: "Sun, Aug 30, 2026",
    time: "3:00pm - 6:00pm",
    location: "Outlets at Castle Rock",
    address: "5050 Factory Shops Blvd, Castle Rock, CO 80108, USA",
    description: "Catch 6202 live at the Rock the Mountain Concert Series.",
    logo: OutletsLogo,
    link: "https://www.outletsatcastlerock.com/events",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3082.450408874007!2d-104.87534448794143!3d39.413938271499894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c9993ebd826ab%3A0xe5c22e325189977a!2sOutlets%20at%20Castle%20Rock!5e0!3m2!1sen!2sus!4v1775515999948!5m2!1sen!2sus",
  },
  {
    id: 13,
    title: "6202 Live at Wrigley's – Sunday Funday Show",
    date: "Sun, Sep 13, 2026",
    time: "3:00pm - 7:00pm",
    location: "Wrigley's Chicago Bar & Grill",
    address: "18200 W Colfax Ave, Golden, CO 80401, USA",
    description:
      "Wrap up your weekend with 6202 at Wrigley’s. A laid-back Sunday show featuring great tunes, drinks, and mountain views.",
    logo: "https://static.spotapps.co/website_images/ab_websites/86277_website_v2/logo_new.png",
    link: "https://www.wrigleyschicagobar.net/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7649.01668374426!2d-105.20194418293227!3d39.71689675468152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b84a526ece61f%3A0xe7a24f1d4def9111!2sWrigley%27s%20Chicago%20Bar%20%26%20Grill!5e0!3m2!1sen!2sus!4v1769273472351!5m2!1sen!2sus",
  },
  {
    id: 14,
    title: "6202 Returns to Frontier Club – Fall Night Rock Show",
    date: "Sat, Sep 19, 2026",
    time: "8:00pm - 12:00am",
    location: "The Frontier Club",
    address: "18881 E Colfax Ave #4, Aurora, CO 80011, USA",
    description:
      "Fall nights hit different at Frontier Club. Catch 6202 bringing the energy with a stacked setlist and a packed dance floor.",
    logo: FrontierClubLogo,
    link: "https://www.thefrontierclubaurora.com/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29193.73561161145!2d-104.76297589026187!3d39.72586896213633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c63c40dc2af9d%3A0x294d72ce21dd2ae2!2sThe%20Frontier%20Club!5e0!3m2!1sen!2sus!4v1716481108592!5m2!1sen!2sus",
  },
  {
    id: 15,
    title: "Sunday Funday at Platte River – Live with 6202",
    date: "Sun, Sep 27, 2026",
    time: "1:00pm - 5:00pm",
    location: "Platte River Bar & Grill",
    address: "5995 S Santa Fe Dr, Littleton, CO 80120, USA",
    description:
      "Close out your weekend with 6202 at Platte River Bar & Grill. Join us from 1–5pm for an afternoon of rock favorites, relaxed river vibes, and great company.",
    logo: "https://static.wixstatic.com/media/6f0583_fe575d3ea44a4511aa0ede5333f9ddd5~mv2.png/v1/fill/w_133,h_73,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/Platte-River-Grill-logo_black.png",
    link: "https://www.theplatteriverbarandgrill.com/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3073.8585748221467!2d-105.02144620000001!3d39.6078682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c81d2039fe33b%3A0xb64c232dfb5265c2!2sPlatte%20River%20Bar%20and%20Grill!5e0!3m2!1sen!2sus!4v1743886014612!5m2!1sen!2sus",
  },
  {
    id: 15.5,
    title: "6202 Live at Greenfield’s – Saturday Night Rock Show",
    date: "Sat, Oct 3, 2026",
    time: "8:00pm - 12:00am",
    location: "Greenfield's Pool & Sports Bar",
    address: "3355 S Yarrow St E101, Lakewood, CO 80227, USA",
    description: "6202 hits Greenfield’s for a Saturday night packed with rock favorites.",
    logo: "https://img1.wsimg.com/isteam/ip/0ca600d5-a580-40b5-ad95-b7c4b4f7b18f/4442d3a6-6c6a-47fb-a48b-fe73880694f4.png/:/rs=w:159,h:106,cg:true,m/cr=w:159,h:106/qt=q:100/ll",
    link: "https://greenfieldsbar.com/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6143.56885764504!2d-105.08625812345643!3d39.654565801673684!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b81d20db6f029%3A0x57debcf670f6b798!2sGreenfields%20Pool%20%26%20Sports%20Bar!5e0!3m2!1sen!2sus!4v1713718305493!5m2!1sen!2sus",
  },
  {
    id: 16,
    title: "6202 Live at Wrigley's – Fall Patio Show",
    date: "Sat, Oct 17, 2026",
    time: "4:00pm - 8:00pm",
    location: "Wrigley's Chicago Bar & Grill",
    address: "18200 W Colfax Ave, Golden, CO 80401, USA",
    description:
      "Celebrate fall with 6202 at Wrigley’s. An afternoon outdoor show filled with crowd favorites and crisp Colorado air.",
    logo: "https://static.spotapps.co/website_images/ab_websites/86277_website_v2/logo_new.png",
    link: "https://www.wrigleyschicagobar.net/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7649.01668374426!2d-105.20194418293227!3d39.71689675468152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876b84a526ece61f%3A0xe7a24f1d4def9111!2sWrigley%27s%20Chicago%20Bar%20%26%20Grill!5e0!3m2!1sen!2sus!4v1769273472351!5m2!1sen!2sus",
  },
  {
    id: 17,
    title: "6202 Rocks the House at Takoda Tavern",
    date: "Fri, Oct 30, 2026",
    time: "7:30pm - 11:30pm",
    location: "Takoda Tavern",
    address: "12365 Pine Bluffs Way, Parker, CO 80134, USA",
    description:
      "Get ready for a Friday night of classic rock, modern favorites, and great energy as 6202 returns to Takoda Tavern. Grab a drink, bring some friends, and rock into the weekend with us.",
    logo: "http://nebula.wsimg.com/61ee8aaed0b74e6676d11f86c8ae73eb?AccessKeyId=F95A2FBD5F21156E5012&disposition=0&alloworigin=1",
    link: "http://www.takodatavern.com/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3079.008369609031!2d-104.75976522346205!3d39.49172561141725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c91865e8c9181%3A0x4b6ef77cfb153c42!2sTakoda%20Tavern!5e0!3m2!1sen!2sus!4v1713718792379!5m2!1sen!2sus",
  },
  {
    id: 18,
    title: "Christmas Weekend Live with 6202 at Takoda Tavern",
    date: "Sat, Dec 26, 2026",
    time: "7:30pm - 11:30pm",
    location: "Takoda Tavern",
    address: "12365 Pine Bluffs Way, Parker, CO 80134, USA",
    description:
      "Keep the holiday spirit alive with an evening of live rock music at Takoda Tavern. 6202 brings the soundtrack for a fun night of great songs, good company, and post-Christmas celebration.",
    logo: "http://nebula.wsimg.com/61ee8aaed0b74e6676d11f86c8ae73eb?AccessKeyId=F95A2FBD5F21156E5012&disposition=0&alloworigin=1",
    link: "http://www.takodatavern.com/",
    mapEmbed:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3079.008369609031!2d-104.75976522346205!3d39.49172561141725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c91865e8c9181%3A0x4b6ef77cfb153c42!2sTakoda%20Tavern!5e0!3m2!1sen!2sus!4v1713718792379!5m2!1sen!2sus",
  },
];

export default events;
